import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { pay } from "../../../services/credit";
import { ToastContext } from "../../../hooks/context";
import {
  useGetBankList,
  useGetBusinessCashOnHand,
} from "../../../hooks/api/queries";
import { cleanObject } from "../../../helpers";
import { useCloseOtpAuthorizationPrompt } from "../../../hooks/useCloseOtpAuthorizationPrompt";

const UpdateCreditWidgetLogic = ({ closeWidget, customer, onSuccess }) => {
  const [amount, setAmount] = useState(customer?.outstanding_balance);
  const [store, setStore] = useState("");
  const [note, setNote] = useState("");
  const [account, setAccount] = useState();
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [repaymentDate, setRepaymentDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const triggerToast = useContext(ToastContext);
  const { closeOtpAuthorizationPrompt } = useCloseOtpAuthorizationPrompt();

  const {
    isLoading: isLoadingBankAccountsList,
    data: bankAccount,
    refetch: fetchBankAccountsList,
  } = useGetBankList();

  const { isLoading: cashOnHandIsLoading, data: cashOnHand } =
    useGetBusinessCashOnHand();

  const makeRepayment = () => {
    const data = {
      amount,
      payment_method: paymentMethod,
      store_id: store,
      ledger_account_id: account,
      note: note,
      repayment_date: repaymentDate,
    };
    setIsSubmitting(true);

    pay(customer.id, cleanObject(data))
      .then(() => {
        triggerToast("Payment successful", "success");
        onSuccess();
        closeWidget();
        closeOtpAuthorizationPrompt();
      })
      .catch((error) => {})
      .finally(() => setIsSubmitting(false));
  };

  return {
    amount,
    note,
    setAmount,
    store,
    setStore,
    storeList,
    isSubmitting,
    setIsSubmitting,
    paymentMethod,
    setPaymentMethod,
    makeRepayment,
    bankAccount,
    isLoadingBankAccountsList,
    fetchBankAccountsList,
    account,
    repaymentDate,
    setRepaymentDate,
    setAccount,
    setNote,
    cashOnHandIsLoading,
    cashOnHand,
  };
};

export default UpdateCreditWidgetLogic;
